import moment from "moment";
import { formatRupees } from "../SalaryComponents/salaryComponentData";
import { PERIOD, versionLabel } from "../SalaryTemplates/salaryTemplateData";
import { textOf } from "./employeeSalaryApi";

// Helpers for Employee Salary (its data comes from employeeSalaryApi.js).
// The screen is read-only: a first salary comes from Assign Salary and every
// change from Salary Revision.

export { formatRupees, versionLabel, PERIOD };

export const SALARY_REVISION_PATH = "/admin/payroll/salary/salary-revision";
export const ASSIGN_SALARY_PATH = "/admin/payroll/salary/assign-salary/salary-component";

export const formatDay = (value) => (value ? moment(value).format("DD MMM YYYY") : "–");
export const periodOf = (payBasis) => PERIOD[payBasis] || "month";

// "Staff — Monthly V4", or "–".
export const templateText = (name, version) => (name ? `${name}${version ? ` ${versionLabel(version)}` : ""}` : "–");

const STATUS = {
  Active: { label: "Active", tone: "green" },
  NotUsed: { label: "Active — Not used", tone: "blue" },
  Upcoming: { label: "Upcoming change", tone: "amber" },
};

export const employeeStatus = (employee) => {
  const base = STATUS[employee.status_key] || STATUS.Active;
  let detail = employee.status_detail;
  if (!detail && employee.status_key === "Upcoming" && employee.upcoming) {
    const { gross, from } = employee.upcoming;
    detail = [gross != null ? `${formatRupees(gross)}${employee.pay_basis === "Daily" ? " / day" : ""}` : null, from ? `from ${moment(from).format("DD MMM")}` : null]
      .filter(Boolean)
      .join(" ");
  }
  if (!detail && employee.status_key === "NotUsed") detail = "Effective, not yet in a payroll";
  return { key: employee.status_key, ...base, detail: detail || "" };
};

const lastChangeDetail = (employee) => {
  if (employee.last_change_detail) return employee.last_change_detail;
  const date = employee.last_change_date || employee.effective_from;
  const month = date ? moment(date).format("MMM YYYY") : "";
  if (employee.last_change_pct == null) return month;
  return [`${employee.last_change_pct >= 0 ? "+" : ""}${employee.last_change_pct}%`, month].filter(Boolean).join(" · ");
};

// The flat row the list and CustomFilter work on.
export const toEmployeeRow = (employee) => {
  const status = employeeStatus(employee);
  return {
    id: employee.id,
    name: textOf(employee.name),
    code: textOf(employee.code),
    department: textOf(employee.department),
    payroll_group: textOf(employee.group),
    template: templateText(employee.template_name, employee.template_version),
    structure: employee.customized ? "Customized" : "Template Linked",
    gross: employee.gross,
    period: periodOf(employee.pay_basis),
    effective_from: employee.effective_from,
    effective_label: formatDay(employee.effective_from),
    last_change: textOf(employee.last_change) || "–",
    last_change_detail: textOf(lastChangeDetail(employee)),
    status: status.label,
    status_key: status.key,
    status_tone: status.tone,
    status_detail: textOf(status.detail),
  };
};
